import styles from "./testimonialcard.module.css";
import { Ratings } from "../../shared";
const TestimonialCard = ({ testimonial }) => {
  const { name, desc, imageUrl, rating ,title } = testimonial;
  return (
    <div className={styles.testimonial__card}>  
      <div className={styles.testimonial__image}>
        <img src={imageUrl} alt={name} />
      </div>
      <div className={styles.testimonial__content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{desc}</p>
        <div className={styles.rating}>
          <Ratings rating={rating} />
        </div>
        <h4 className={styles.name}>{name}</h4>
      </div>
    </div>
  );
};
export default TestimonialCard;